import { ITeasersState } from './teasersContext';
import { TeasersActionTypes, TTeasersActions } from './teasersActions';

export const teasersReducer = (state: ITeasersState, action: TTeasersActions): ITeasersState => {
	switch (action.type) {
		case TeasersActionTypes.SET_TEASERS:
			return {
				...state,
				teasers: action.payload.teasers,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case TeasersActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: action.payload.currentPage,
			};
		case TeasersActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				currentPage: 1,
			};
		case TeasersActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				currentPage: 1,
			};
		case TeasersActionTypes.SET_ID_CONTENT_TYPE:
			return {
				...state,
				IDSelectedContentType: action.payload.IDSelectedContentType,
			};
		case TeasersActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				IDSelectedContentType: null,
				currentPage: 1,
			};
		case TeasersActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case TeasersActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case TeasersActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case TeasersActionTypes.SET_TEASER_ID_FOR_DELETION:
			return {
				...state,
				teaserIDForDeletion: action.payload.teaserIDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case TeasersActionTypes.SET_TEASER_ID_FOR_FULL_INFO:
			return {
				...state,
				teaserIDForFullInfo: action.payload.teaserIDForFullInfo,
			};
		case TeasersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case TeasersActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
